<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col lg:flex-row lg:items-end justify-between mb-4 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">สิทธิ์ผู้ใช้ตามลาน</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        กำหนดว่าผู้ใช้ Backoffice คนไหน ดู/จัดการโควต้าจอดฟรีของลานไหนได้
      </p>
    </div>
    <div class="flex flex-wrap gap-2">
      <button type="button" (click)="onRefresh()" [disabled]="isLoading()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">refresh</span>
        โหลดใหม่
      </button>
      <button type="button" (click)="startAdd()" [disabled]="!canUpdate"
        class="px-4 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold flex items-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">person_add</span>
        เพิ่มสิทธิ์
      </button>
    </div>
  </div>

  <div class="mb-6 rounded-2xl border border-amber-200 dark:border-amber-800/60 bg-amber-50/70 dark:bg-amber-950/20 p-4 md:p-5">
    <p class="font-bold text-amber-900 dark:text-amber-200 mb-2">เริ่มต้นยังไง?</p>
    <ol class="list-decimal list-inside space-y-1 text-amber-900/90 dark:text-amber-100/90 text-sm">
      <li>เลือกลานจากแถบด้านข้าง (ถ้ามี)</li>
      <li>กด <span class="font-bold">เพิ่มสิทธิ์</span> ทางขวา</li>
      <li>เลือกผู้ใช้ → เลือกลาน → ติ๊กสิทธิ์ที่ต้องการ → บันทึก</li>
      <li>คลิกแถวในตารางเพื่อแก้ไข / ดูประวัติ</li>
    </ol>
  </div>

  <div class="flex flex-col sm:flex-row sm:items-center gap-3 mb-6">
    <label class="inline-flex items-center gap-2 cursor-pointer select-none">
      <input type="checkbox" [(ngModel)]="filterOnlySelectedSite" (ngModelChange)="onToggleSiteFilter()" />
      <span class="font-semibold">
        แสดงเฉพาะลานที่เลือก
        <span class="text-amber-600 dark:text-amber-400" *ngIf="selectedSiteName">({{ selectedSiteName }})</span>
      </span>
    </label>
  </div>

  <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

  <div *ngIf="!isLoading()" class="grid grid-cols-1 xl:grid-cols-3 gap-6">
    <div class="xl:col-span-2 bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-xl border border-slate-100/50 overflow-hidden">
      <div class="px-4 py-3 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
        <p class="font-bold text-slate-700 dark:text-slate-200">รายการสิทธิ์ที่มีอยู่</p>
        <span class="text-xs text-slate-400">{{ items().length }} รายการ</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-left min-w-[800px]">
          <thead class="bg-slate-50 dark:bg-slate-800/80">
            <tr>
              <th class="p-4 text-xs font-bold text-slate-400 uppercase">ผู้ใช้</th>
              <th class="p-4 text-xs font-bold text-slate-400 uppercase">ลาน</th>
              <th class="p-4 text-xs font-bold text-slate-400 uppercase">Client</th>
              <th class="p-4 text-xs font-bold text-slate-400 uppercase text-center">สิทธิ์</th>
              <th class="p-4 text-xs font-bold text-slate-400 uppercase text-center w-24">ประวัติ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100 dark:divide-slate-800">
            <tr *ngFor="let row of items(); trackBy: trackRow" (click)="selectRow(row)"
              class="cursor-pointer hover:bg-amber-50/50 dark:hover:bg-slate-800/50"
              [ngClass]="{ 'bg-amber-50 dark:bg-amber-900/20': selectedRow()?.id === row.id }">
              <td class="p-4">
                <div class="font-bold text-slate-800 dark:text-slate-100">{{ row.resUserName || ('User #' + row.resUserId) }}</div>
                <div class="text-xs text-slate-400">ID {{ row.resUserId }}</div>
              </td>
              <td class="p-4">{{ row.siteName || row.siteId }}</td>
              <td class="p-4">{{ row.clientName || (row.clientId ? row.clientId : 'ทั้งลาน') }}</td>
              <td class="p-4 text-center text-xs space-y-1">
                <span class="inline-block px-2 py-0.5 rounded-full font-semibold"
                  [ngClass]="row.active ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-600'">
                  {{ row.active ? 'เปิดใช้' : 'ปิดใช้' }}
                </span>
                <div class="text-slate-500 space-x-1">
                  <span *ngIf="row.canManageQuota" class="inline-block px-1.5 py-0.5 rounded bg-sky-50 text-sky-700">จัดการโควต้า</span>
                  <span *ngIf="row.canDeleteCardReturnQuota" class="inline-block px-1.5 py-0.5 rounded bg-rose-50 text-rose-700">ลบบัตรคืนโควต้า</span>
                  <span *ngIf="!row.canManageQuota && !row.canDeleteCardReturnQuota">ดูอย่างเดียว</span>
                </div>
              </td>
              <td class="p-4 text-center">
                <button type="button" (click)="openHistory(row, $event)"
                  class="p-2 rounded-lg hover:bg-amber-100 text-slate-500 hover:text-amber-600" title="ดูประวัติ">
                  <span class="material-icons text-[20px]">history</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="items().length === 0">
              <td colspan="5" class="p-10 text-center">
                <span class="material-icons text-4xl text-slate-300 mb-2 block">group_add</span>
                <p class="font-bold text-slate-600 dark:text-slate-300 mb-1">ยังไม่มีสิทธิ์ในรายการนี้</p>
                <p class="text-slate-400 mb-4">เริ่มโดยกดปุ่ม “เพิ่มสิทธิ์” แล้วเลือกผู้ใช้ + ลาน</p>
                <button type="button" (click)="startAdd()" [disabled]="!canUpdate"
                  class="px-4 py-2 rounded-xl bg-amber-400 text-white font-bold disabled:opacity-50">
                  เพิ่มสิทธิ์แรก
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="user-site-access-form"
      class="bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-xl border border-slate-100/50 p-6 space-y-4 h-fit">
      <div>
        <h2 class="text-lg font-black text-slate-800 dark:text-slate-100">
          {{ form.id ? 'แก้ไขสิทธิ์' : '1) เพิ่มสิทธิ์ใหม่' }}
        </h2>
        <p class="text-xs text-slate-400 mt-1">กรอกทีละขั้นตอน แล้วกดบันทึก</p>
      </div>

      <div class="space-y-3">
        <div>
          <label class="text-xs font-bold text-slate-500 uppercase">ค้นหาผู้ใช้</label>
          <input type="text" [(ngModel)]="userSearch" placeholder="พิมพ์ชื่อหรือ login..."
            class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900" />
        </div>
        <div>
          <label class="text-xs font-bold text-slate-500 uppercase">ผู้ใช้ Backoffice *</label>
          <select [(ngModel)]="form.resUserId" [disabled]="!canUpdate || isSaving() || !!form.id"
            class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900">
            <option [ngValue]="0">— เลือกผู้ใช้ —</option>
            <option *ngFor="let u of filteredUsers" [ngValue]="u.id">{{ u.label }}</option>
          </select>
          <p *ngIf="form.id" class="text-[11px] text-slate-400 mt-1">แก้ไขรายการเดิม — เปลี่ยนผู้ใช้ไม่ได้ (ล้างฟอร์มเพื่อเพิ่มใหม่)</p>
        </div>

        <div>
          <label class="text-xs font-bold text-slate-500 uppercase">ลาน *</label>
          <select [(ngModel)]="form.siteId" (ngModelChange)="onFormSiteChange()" [disabled]="!canUpdate || isSaving()"
            class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900">
            <option [ngValue]="0">— เลือกลาน —</option>
            <option *ngFor="let s of sites" [ngValue]="s.id">{{ s.name }}</option>
          </select>
        </div>

        <div>
          <label class="text-xs font-bold text-slate-500 uppercase">Client (ไม่บังคับ)</label>
          <select [(ngModel)]="form.clientId" [disabled]="!canUpdate || isSaving()"
            class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900">
            <option [ngValue]="null">ทั้งลาน (ไม่จำกัด Client)</option>
            <option *ngFor="let c of clients()" [ngValue]="c.id">{{ c.name }}</option>
          </select>
        </div>

        <div class="rounded-xl border border-slate-100 dark:border-slate-800 p-3 space-y-2 bg-slate-50/80 dark:bg-slate-800/40">
          <p class="text-xs font-bold text-slate-500 uppercase">สิทธิ์ที่ให้</p>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" class="mt-1" [(ngModel)]="form.active" [disabled]="!canUpdate || isSaving()" />
            <span>
              <span class="font-bold text-sm block">เปิดใช้งาน</span>
              <span class="text-xs text-slate-400">ปิดไว้ = ยังผูกไว้แต่ใช้ไม่ได้</span>
            </span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" class="mt-1" [(ngModel)]="form.canManageQuota" [disabled]="!canUpdate || isSaving()" />
            <span>
              <span class="font-bold text-sm block">จัดการโควต้าจอดฟรีได้</span>
              <span class="text-xs text-slate-400">ตั้ง/แก้โควต้าลาน และแจกให้ Client</span>
            </span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" class="mt-1" [(ngModel)]="form.canDeleteCardReturnQuota" [disabled]="!canUpdate || isSaving()" />
            <span>
              <span class="font-bold text-sm block">ลบบัตรแล้วคืนโควต้าได้</span>
              <span class="text-xs text-slate-400">หมดอายุอย่างเดียวไม่คืนโควต้า</span>
            </span>
          </label>
        </div>
      </div>

      <div class="flex flex-wrap gap-2 pt-2">
        <button type="button" (click)="onSave()" [disabled]="!canUpdate || isSaving()"
          class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
        <button type="button" (click)="resetForm()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold">
          ล้างฟอร์ม
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.UserSiteAccess"
  [entityId]="historyEntityId"
  [title]="'ประวัติสิทธิ์ผู้ใช้ตามลาน'"
  [subtitle]="historyRow()?.resUserName || ''"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showConfirm"
  [title]="confirmTitle"
  [message]="confirmMessage"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  confirmLabel="ใช่"
  cancelLabel="ไม่"
  [variant]="confirmVariant"
  [icon]="confirmIcon"
  [loading]="confirmLoading"
  [showIrreversibleNote]="confirmVariant === 'danger'"
  (confirm)="onConfirmYes()"
  (cancel)="onConfirmNo()">
</app-pss-confirm-modal>
